import classNames from 'classnames';
import { Button } from 'react-aria-components/Button';
import { Tooltip, TooltipTrigger } from 'react-aria-components/Tooltip';

import { ProductImageTranslation } from '../../localization/ModuleTranslation';
import Image from '../../ui/Image/Image';
import css from './ProductImage.css';

const imageParams = {
  width: 218,
  height: 218,
  scalingMode: 'fit',
  sharpeningFactor: 2,
  size: 'contain',
} as const;

interface ProductImageProps {
  imageUrl: string;
  productDescription: string;
  productName: string;
  size: 'small' | 'medium';
  translation: ProductImageTranslation;
}

const ProductImage = ({ imageUrl, productName, productDescription, size, translation }: ProductImageProps) => {
  return (
    <TooltipTrigger delay={400} closeDelay={0}>
      <Button className={css.trigger}>
        <Image
          className={classNames(css.thumbnail, css[size])}
          src={imageUrl}
          alt={translation.enlargeImageFormat.interpolate([['name', productName]])}
          {...imageParams}
        />
      </Button>
      <Tooltip className={css.content} offset={16} placement="right">
        <figure>
          <Image className={css.image} src={imageUrl} alt={productName} {...imageParams} />
          <figcaption className={css.caption}>
            <div className={css.name}>{productName}</div>
            {productDescription && <div className={css.description}>{productDescription}</div>}
          </figcaption>
        </figure>
      </Tooltip>
    </TooltipTrigger>
  );
};

export default ProductImage;
